import Editor from './src/editor.js';

export default { Editor };
